import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import mixinWhiteLabel from './mixins';
import i18n from './helpers/i18n';
import axios from 'axios';
import VueAxios from 'vue-axios';
import axiosRetry from 'axios-retry';
import validatorEs from '@/helpers/validator/es';
import VeeValidate, { Validator } from 'vee-validate';
import Vue2Filters from 'vue2-filters';
import moment from 'moment-timezone';
import VueMoment from 'vue-moment';
import Dropdown from 'hsy-vue-dropdown';
import LocalStorage from 'store';
// import VueSocketIO from 'vue-socket.io-extended';
// import io from 'socket.io-client';
import VCalendar from 'v-calendar';
import VueMobileDetection from 'vue-mobile-detection';
import 'moment/locale/es';
//
import Fragment from 'vue-fragment';
// VueLoaders
import 'vue-loaders/dist/vue-loaders.css';
import * as VueLoaders from 'vue-loaders';

// Vue Notifiations
import Notifications from 'vue-notification';

// Buefy Declaration
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';

// V-mask
import VueMask from 'v-mask';
// import 'buefy/dist/buefy.css'
import analyticClient from './analytics/analyticClient';

Vue.config.productionTip = false;

// Axios
const Axios = axios.create({
  baseURL: process.env.VUE_APP_URL_MENU_DIGITAL,
  withCredentials: false
});
axiosRetry(Axios, { retries: 1 });
Axios.interceptors.request.use((request) => {
  if (LocalStorage.get('_token')) {
    request.headers.Authorization = 'Bearer ' + LocalStorage.get('_token');
  }
  if (request.data && !request.headers['Content-Type']) {
    request.headers.Accept = 'application/json';
    request.headers['Content-Type'] = 'application/json';
    request.data = JSON.stringify(request.data);
  }
  return request;
});
Axios.interceptors.response.use(undefined, err => {
  const res = err.response;
  if (res.status === 401 && res.config && !res.config.__isRetryRequest) {
    LocalStorage.clearAll();
    return Promise.reject(err);
  }
  if (res.status === 403) {
    return Promise.reject(err);
  }
});
moment.tz.setDefault('America/Bogota');
// const vendorId = LocalStorage.get('_id') || 0;

// Vue.use(
//   VueSocketIO,
//   io(process.env.VUE_APP_WS, {
//     autoConnect: !!vendorId,
//     transports: ['websocket'],
//     query: {
//       vendorId
//     }
//   })
// );
analyticClient(Axios);
Vue.use(Buefy);
Vue.use(VueMask);
Vue.use(Dropdown);
Vue.use(VueLoaders);
Vue.use(Vue2Filters);
Vue.use(VueMobileDetection);
Vue.use(VeeValidate);
Vue.use(Notifications);
Vue.use(VCalendar);
Validator.localize('es', validatorEs);
Vue.use(VueMoment, {
  moment
});
Vue.filter('truncate', function (value, limit) {
  if (value.length > limit) {
    value = value.substring(0, limit - 3) + '...';
  }
  return value;
});

Vue.mixin(mixinWhiteLabel);
Vue.use(VueAxios, Axios);
Vue.use(Fragment.Plugin);
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
